var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTrialAccount && _vm.trialStartDate)?_c('div',{staticClass:"trial-countdown"},[_vm._v("\n  You have "),_c('span',{staticClass:"days"},[_vm._v(_vm._s(_vm.daysLeft)+" days")]),_vm._v(" left on your trial\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }